<rr-textarea
    [required]="true"
    [(ngModel)]="userInput"
    label="Your Input"
    [limitCharacters]="2500"
    maxheight="30vh"
    minheight="100%"
    class="h100"
></rr-textarea>
<!-- Disclaimer INFO  -->
<rr-disclaimer [type]="disclaimerTypes.DATA"></rr-disclaimer>

<div class="btnrow row w100 gap-16 justify-end align-center">
    <div class="row gap-8">
        <rr-btn
            size="Small"
            type="Secondary"
            (click)="close.emit()"
            [disabled]="editResponse"
            >Cancel</rr-btn
        >
        <rr-btn
            size="Small"
            type="Primary"
            [disabled]="userInput.trim().length === 0 || editResponse"
            (click)="userInput.trim().length === 0 ? null : summariseText()"
            >Use content
        </rr-btn>
    </div>
</div>
<rr-spinner *ngIf="loading"></rr-spinner>
